export default class Record{
    constructor() {
        this.id=0;
    }
}